import {formatDuration} from 'components/dashboard/coaching-effectiveness/common';
import moment from 'moment';

export const toHHMM = seconds => formatDuration(moment.duration(seconds, 'seconds'));

export const safePercent = (value, max) => {
  if (max === 0) {
    return 100;
  }

  return (value / max) * 100;
};
